import React from 'react';

import './progressBarComponent.css';

const ProgressBarComponent = ({
  showBarTxtWhenFinished = false,
  barText = null,
  percentage = 0,
}) => {
  return (
    <div className="et-v2-progress-bar-container">
      <div
        className="et-v2-progress-bar-filled"
        style={{width: `${percentage}%`}}></div>
      {percentage > 0 && (
        <div
          className={`et-v2-progress-bar-percentage-txt ${
            percentage >= 47 ? 'et-v2-progress-bar-percentage-white-txt' : ''
          }`}>
          {showBarTxtWhenFinished && barText ? barText : `${percentage}%`}
        </div>
      )}
    </div>
  );
};

export default ProgressBarComponent;
